import React, {useEffect} from 'react';
import {navigate} from '@reach/router';
import SalesIndex from './join';

export default function () {
  useEffect(() => {
    navigate('/a/cancer/join/' + location.search);
  }, []);
  return <SalesIndex />;
}
